import React, { useEffect, useState } from 'react';
import {
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonMenu,
    IonMenuToggle,
    IonNote,
} from '@ionic/react';

import { useLocation } from 'react-router-dom';
import { archiveOutline, archiveSharp, bookmarkOutline, heartOutline, heartSharp, mailOutline, mailSharp, paperPlaneOutline, paperPlaneSharp, trashOutline, trashSharp, warningOutline, warningSharp } from 'ionicons/icons';
import './Menu.css';

import ClassThreeMenu from '../menus/ClassThree/ClassThree';
import ClassFourMenu from '../menus/ClassFour/ClassFour';
import ClassFiveMenu from '../menus/ClassFive/ClassFive';
import ClassTwoMenu from '../menus/ClassTwo/ClassTwo';
import ClassOneMenu from '../menus/ClassOne/ClassOne';
import UKGMenu from '../menus/UKG/UKG';
import LKGMenu from '../menus/LKG/LKG';
import NurseryMenu from '../menus/Nursery/Nursery';

import ClassTwoOlympiadMenu from '../menus/Olympiad/ClassTwo';
import ClassThreeOlympiadMenu from '../menus/Olympiad/ClassThree';
import ClassOneOlympiadMenu from '../menus/Olympiad/ClassOne';


import LogicalReasoning from '../menus/LogicalReasoning';

// Define the type for the menu items
interface MenuItem {
    url: string;
    title: string;
    subMenu?: MenuItem[]; // Add sub-menu items as optional
    component?: React.FC;
}

const Menu: React.FC = () => {
    const location = useLocation();
    const [activeMenu, setActiveMenu] = useState<string | null>(null); // Manage which menu is active (for toggling sub-menus)
    let menus: MenuItem[] = []; // Initialize menuItems with a proper type
    const [menuItems, setMenuItems] = useState<MenuItem[]>([])

    menus = [
        {
            url: "/nursery",
            title: "Nursery",
            subMenu: NurseryMenu
        },
        {
            url: "/lkg",
            title: "LKG",
            subMenu: LKGMenu
        },
        {
            url: "/ukg",
            title: "UKG",
            subMenu: UKGMenu
        },
        {
            url: "/class-one",
            title: "Class 1",
            subMenu: ClassOneMenu
        },
        {
            url: "/class-two",
            title: "Class 2",
            subMenu: ClassTwoMenu
        },
        {
            url: "/class-three",
            title: "Class 3",
            subMenu: ClassThreeMenu
        },
        {
            url: "/class-four",
            title: "Class 4",
            subMenu: ClassFourMenu
        },
        {
            url: "/class-five",
            title: "Class 5",
            subMenu: ClassFiveMenu
        }
    ];

    useEffect(() => {
        const element = document.getElementsByClassName("selected")[0];
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth', // Smooth scrolling animation
                block: 'center',    // Align the item in the center of the viewport
            });
        }
    }, [location.pathname])

    let olymmenus: MenuItem[] = []; // Initialize menuItems with a proper type


    olymmenus = [
        {
            url: "/logical-reasoning",
            title: "Logical Reasoning",
            subMenu: LogicalReasoning
        },
        {
            url: "/olympiad-classone",
            title: "Class 1",
            subMenu: ClassOneOlympiadMenu
        },
        {
            url: "/olympiad-classtwo",
            title: "Class 2",
            subMenu: ClassTwoOlympiadMenu
        },
        {
            url: "/olympiad-classthree",
            title: "Class 3",
            subMenu: ClassThreeOlympiadMenu
        }
    ];


    return (
        <>
                <a href="/" style={{ textDecoration: 'none', borderBottom: '1px solid #ccc' }}>
                    <div className='text-center height-40' style={{ background: 'linear-gradient(135deg, #f0fdf4, #0c706d)' }}>
                        <img className='img-fluid height-30' src='assets/logo-500.png' />
                        {/* <span className='font-weight-bold font-25' style={{ display: 'block', fontFamily: 'cursive' }}><span className='yellowText'>Mamas</span>&nbsp;<span className='orangeText'>Guidance</span></span> */}
                    </div>
                </a>
                <IonContent className='innerPage'>
                    <IonList id="inbox-list" className='ion-list-class mb-5'>
                        <div className='menuList'>
                            {menus.map((item: MenuItem, index: number) => {
                                return (
                                    <IonMenuToggle key={index} autoHide={false}>
                                        <IonItem className={location.pathname === item.url ? 'selected' : ''} routerLink={item.url} routerDirection="none" lines="none" detail={false}>
                                            {/* <IonIcon aria-hidden="true" slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} /> */}
                                            <IonLabel>{item.title}</IonLabel>
                                        </IonItem>
                                        {/* Render sub-menu if it exists and the current menu is active */}
                                        {item.subMenu && (
                                            <ul className="sub-menu">
                                                {item.url.includes(location.pathname.split('/')[1]) && item.subMenu.map((subItem, subIndex) => (
                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                        <IonItem
                                                            className={location.pathname === subItem.url ? 'selected' : ''}
                                                            routerLink={subItem.url}
                                                            routerDirection="none"
                                                            lines="none"
                                                            detail={false}
                                                        >
                                                            <IonLabel>{subItem.title}</IonLabel>
                                                        </IonItem>
                                                        {location.pathname.includes(subItem.url) && subItem.subMenu && (
                                                            <ul className="sub-menu">
                                                                {subItem.subMenu?.map((subSubItem, subIndex) => (
                                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                                        <IonItem
                                                                            className={location.pathname == (subSubItem.url) ? 'selected' : ''}
                                                                            routerLink={subSubItem.url}
                                                                            routerDirection="none"
                                                                            lines="none"
                                                                            detail={false}
                                                                        >
                                                                            <IonLabel>{subSubItem.title}</IonLabel>
                                                                        </IonItem>
                                                                        {(location.pathname.includes(subSubItem.url)) && subSubItem.subMenu && (
                                                                            <ul className="sub-menu">
                                                                                {subSubItem.subMenu?.map((subSubSubItem, subIndex) => (
                                                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                                                        <IonItem
                                                                                            className={location.pathname == (subSubSubItem.url) ? 'selected' : ''}
                                                                                            routerLink={subSubSubItem.url}
                                                                                            routerDirection="none"
                                                                                            lines="none"
                                                                                            detail={false}
                                                                                        >
                                                                                            <IonLabel>{subSubSubItem.title}</IonLabel>
                                                                                        </IonItem>
                                                                                        {(location.pathname.includes(subSubSubItem.url)) && subSubSubItem.subMenu && (
                                                                                            <ul className="sub-menu">
                                                                                                {subSubSubItem.subMenu?.map((subSubSubSubItem, subIndex) => (
                                                                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                                                                        <IonItem
                                                                                                            className={location.pathname == (subSubSubSubItem.url) ? 'selected' : ''}
                                                                                                            routerLink={subSubSubSubItem.url}
                                                                                                            routerDirection="none"
                                                                                                            lines="none"
                                                                                                            detail={false}
                                                                                                        >
                                                                                                            <IonLabel>{subSubSubSubItem.title}</IonLabel>
                                                                                                        </IonItem>

                                                                                                    </IonMenuToggle>
                                                                                                ))}
                                                                                            </ul>
                                                                                        )}
                                                                                    </IonMenuToggle>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </IonMenuToggle>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </IonMenuToggle>
                                                ))}
                                            </ul>
                                        )}
                                    </IonMenuToggle>
                                );
                            })}
                        </div>
                    </IonList>
                    <IonLabel class='newSection'>OLYMPIADS</IonLabel>
                    <IonList id="inbox-list1" className='ion-list-class'>
                        <div className='menuList'>
                            {olymmenus.map((item: MenuItem, index: number) => {
                                return (
                                    <IonMenuToggle key={"1" + index} autoHide={false}>
                                        <IonItem className={location.pathname === item.url ? 'selected' : ''} routerLink={item.url} routerDirection="none" lines="none" detail={false}>
                                            {/* <IonIcon aria-hidden="true" slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} /> */}
                                            <IonLabel>{item.title}</IonLabel>
                                        </IonItem>
                                        {/* Render sub-menu if it exists and the current menu is active */}
                                        {item.subMenu && (
                                            <ul className="sub-menu">
                                                {item.url.includes(location.pathname.split('/')[1]) && item.subMenu.map((subItem, subIndex) => (
                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                        <IonItem
                                                            className={location.pathname === subItem.url ? 'selected' : ''}
                                                            routerLink={subItem.url}
                                                            routerDirection="none"
                                                            lines="none"
                                                            detail={false}
                                                        >
                                                            <IonLabel>{subItem.title}</IonLabel>
                                                        </IonItem>
                                                        {location.pathname.includes(subItem.url) && subItem.subMenu && (
                                                            <ul className="sub-menu">
                                                                {subItem.subMenu?.map((subSubItem, subIndex) => (
                                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                                        <IonItem
                                                                            className={location.pathname == (subSubItem.url) ? 'selected' : ''}
                                                                            routerLink={subSubItem.url}
                                                                            routerDirection="none"
                                                                            lines="none"
                                                                            detail={false}
                                                                        >
                                                                            <IonLabel>{subSubItem.title}</IonLabel>
                                                                        </IonItem>
                                                                        {(location.pathname.includes(subSubItem.url)) && subSubItem.subMenu && (
                                                                            <ul className="sub-menu">
                                                                                {subSubItem.subMenu?.map((subSubSubItem, subIndex) => (
                                                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                                                        <IonItem
                                                                                            className={location.pathname == (subSubSubItem.url) ? 'selected' : ''}
                                                                                            routerLink={subSubSubItem.url}
                                                                                            routerDirection="none"
                                                                                            lines="none"
                                                                                            detail={false}
                                                                                        >
                                                                                            <IonLabel>{subSubSubItem.title}</IonLabel>
                                                                                        </IonItem>
                                                                                        {(location.pathname.includes(subSubSubItem.url)) && subSubSubItem.subMenu && (
                                                                                            <ul className="sub-menu">
                                                                                                {subSubSubItem.subMenu?.map((subSubSubSubItem, subIndex) => (
                                                                                                    <IonMenuToggle key={subIndex} autoHide={false}>
                                                                                                        <IonItem
                                                                                                            className={location.pathname == (subSubSubSubItem.url) ? 'selected' : ''}
                                                                                                            routerLink={subSubSubSubItem.url}
                                                                                                            routerDirection="none"
                                                                                                            lines="none"
                                                                                                            detail={false}
                                                                                                        >
                                                                                                            <IonLabel>{subSubSubSubItem.title}</IonLabel>
                                                                                                        </IonItem>

                                                                                                    </IonMenuToggle>
                                                                                                ))}
                                                                                            </ul>
                                                                                        )}
                                                                                    </IonMenuToggle>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </IonMenuToggle>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </IonMenuToggle>
                                                ))}
                                            </ul>
                                        )}
                                    </IonMenuToggle>
                                );
                            })}
                        </div>
                    </IonList>
                </IonContent>
        </>
    );
};

export default Menu;
